import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import { setBackground } from 'utils/styled/setBackground'

export const Wrapper = styled.div`
  position: relative;
  width: ${em(420)};
  max-width: 90%;
  height: ${em(320)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    width: ${em(350)};
    max-width: 100%;
    background-position: 0 0;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(469)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
  }
`

export const Shadow = styled.div`
  display: none;
  position: absolute;
  background: 0 100% / contain no-repeat;
  ${p => setBackground('png', p.imgUrl, { md: 450 }, false)};
  width: 130%;
  height: 100%;
  left: -27%;
  bottom: -${em(40)};
  opacity: 0.7;

  ${p => p.theme.mq.upMd} {
    display: block;
  }

  ${p => p.theme.mq.upLg} {
    bottom: -${em(125)};
  }
`
